/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'resource/ideology': {
    width: 20,
    height: 20,
    viewBox: '0 0 20 20',
    data: '<circle pid="0" cx="10" cy="5" r="1.001"/><circle pid="1" cx="10" cy="15" r="1.001"/><path pid="2" d="M10 0C4.478 0 0 4.478 0 10s4.478 10 10 10c5.523 0 10-4.478 10-10S15.523 0 10 0zm0 1.999c1.654 0 3 1.347 3 3.001s-1.346 3.001-3 3.001S7 6.655 7 5s1.346-3.001 3-3.001zm-4.27 5.65a.5.5 0 01.702.092C7.291 8.859 8.592 9.5 10 9.5s2.709-.641 3.568-1.759a.501.501 0 01.793.609c-1.05 1.366-2.64 2.15-4.361 2.15s-3.311-.784-4.361-2.15a.5.5 0 01.091-.701zm11.162 5.271a10.482 10.482 0 01-3.896 2.13 3.002 3.002 0 01-2.995 2.952 3 3 0 01-2.995-2.956 10.461 10.461 0 01-3.897-2.127.5.5 0 01.656-.754 9.499 9.499 0 003.403 1.892 2.994 2.994 0 012.833-2.058c1.324 0 2.438.869 2.835 2.062a9.488 9.488 0 003.4-1.895.5.5 0 11.656.754z"/>'
  }
})
